import { BS } from "../../../../Contracts";
import { QueryFactory } from "../../../../Common";
export const QGetPurchases = QueryFactory(BS.QueryTypes.GetPurchases);
//# sourceMappingURL=QGetPurchases.js.map